const svgBase64 = (svgString) => `data:image/svg+xml;base64,${btoa(svgString)}`;

export default svgBase64;
